// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../node_modules/react-complex-tree/lib/style-modern.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
    "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

#root {
  display: flex;
  align-items: stretch;
  min-height: 100vh;
}

a {
  color: inherit;
  text-decoration: none;
}

*::selection {
  background: royalblue;
  color: white;
}

/* React Complex Tree Styles */

/* Custom APS File Browser Styles */
:root {
  --rct-color-tree-focus-outline: transparent;
  --rct-color-focustree-item-selected-bg: transparent;
  --rct-color-focustree-item-selected-text: inherit;
  --rct-color-focustree-item-focused-border: transparent;
  --rct-color-focustree-item-draggingover-bg: transparent;
  --rct-color-focustree-item-draggingover-color: inherit;
  --rct-color-focustree-item-hover-bg: transparent;
  --rct-color-focustree-item-active-bg: #fff2;
  --rct-color-focustree-item-active-text: inherit;
  
}

/* Hover effect with 20% white opacity */
/* .rct-tree-item-li:hover .rct-tree-item-title-container {
  background-color: rgba(255, 255, 255, 0.2) !important;
} */

/* Remove selection highlighting */
.rct-tree-item-li[data-rct-item-selected="true"] .rct-tree-item-title-container {
  background-color: transparent !important;
}

.rct-tree-item-li[data-rct-item-focus="true"] .rct-tree-item-title-container {
  background-color: transparent !important;
  outline: none !important;
}

/* Remove background from tree container */
.rct-tree-root {
  background-color: transparent !important;
}

.rct-tree-item-button {
  padding-block: 1rem !important;
  /* padding-inline: 0.5rem !important; */
}

.rct-tree-item-button p {
  font-size: 1rem !important;
}
  `, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;8CAC4C;EAC5C,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA,8BAA8B;;AAG9B,mCAAmC;AACnC;EACE,2CAA2C;EAC3C,mDAAmD;EACnD,iDAAiD;EACjD,sDAAsD;EACtD,uDAAuD;EACvD,sDAAsD;EACtD,gDAAgD;EAChD,2CAA2C;EAC3C,+CAA+C;;AAEjD;;AAEA,wCAAwC;AACxC;;GAEG;;AAEH,kCAAkC;AAClC;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\",\n    \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  min-height: 100vh;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n#root {\n  display: flex;\n  align-items: stretch;\n  min-height: 100vh;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n*::selection {\n  background: royalblue;\n  color: white;\n}\n\n/* React Complex Tree Styles */\n@import \"react-complex-tree/lib/style-modern.css\";\n\n/* Custom APS File Browser Styles */\n:root {\n  --rct-color-tree-focus-outline: transparent;\n  --rct-color-focustree-item-selected-bg: transparent;\n  --rct-color-focustree-item-selected-text: inherit;\n  --rct-color-focustree-item-focused-border: transparent;\n  --rct-color-focustree-item-draggingover-bg: transparent;\n  --rct-color-focustree-item-draggingover-color: inherit;\n  --rct-color-focustree-item-hover-bg: transparent;\n  --rct-color-focustree-item-active-bg: #fff2;\n  --rct-color-focustree-item-active-text: inherit;\n  \n}\n\n/* Hover effect with 20% white opacity */\n/* .rct-tree-item-li:hover .rct-tree-item-title-container {\n  background-color: rgba(255, 255, 255, 0.2) !important;\n} */\n\n/* Remove selection highlighting */\n.rct-tree-item-li[data-rct-item-selected=\"true\"] .rct-tree-item-title-container {\n  background-color: transparent !important;\n}\n\n.rct-tree-item-li[data-rct-item-focus=\"true\"] .rct-tree-item-title-container {\n  background-color: transparent !important;\n  outline: none !important;\n}\n\n/* Remove background from tree container */\n.rct-tree-root {\n  background-color: transparent !important;\n}\n\n.rct-tree-item-button {\n  padding-block: 1rem !important;\n  /* padding-inline: 0.5rem !important; */\n}\n\n.rct-tree-item-button p {\n  font-size: 1rem !important;\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
